import * as Sentry from "@sentry/react";
import { useEffect } from "react";

export default function useCaptureException(error) {
  useEffect(() => {
    Sentry.withScope((scope) => {
      if (error.combinedError?.graphQLErrors?.length > 0) {
        scope.setExtras({
          graphQLErrors: error.combinedError.graphQLErrors.map((error) => ({
            message: error.message,
            path: error.path,
            ...(error.extensions?.code && { code: error.extensions.code }),
          })),
        });
      }
      Sentry.captureException(error);
    });
  }, [error]);
}
